import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const isLoadingSelector = createSelector(
  (state: RootState) => state.ui.countAction,
  (countAction) => countAction > 0,
);
